import React, { useState } from 'react';
import FeedbackModalUI from './FeedbackModalUI';
import FeedbackSuccessModal from './FeedbackSuccessModal';
import axios from 'axios';

const Feedback = ({ onClose }) => {
  // Business state management
  const [activeTab, setActiveTab] = useState('Bug');
  const [title, setTitle] = useState('');
  const [priority, setPriority] = useState('1');
  const [severity, setSeverity] = useState('1 - Critical');
  const [reproSteps, setReproSteps] = useState('');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [feedbackId, setFeedbackId] = useState(null);
  const [loading, setLoading] = useState(false);

  const apiURL = process.env.REACT_APP_API_URL;

  // Utility: Get the current URL for system info
  const getSystemInfo = () => window.location.href;

  // Validate required fields for Bug and Task feedback
  const validateFields = () => {
    if (!title.trim()) return 'Title is required';
    if (activeTab === 'Bug') {
      if (!priority.trim() || !severity.trim() || !reproSteps.trim())
        return 'All bug fields are required';
    } else if (activeTab === 'Task') {
      if (!description.trim()) return 'Description is required';
    }
    return null;
  };

  // Handle form submission (for both submit and submit & add another)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
  
    // Validate fields
    const error = validateFields();
    if (error) {
      setErrorMessage(error);
      return;
    }
  
    // Construct payload based on active tab
    const payload =
      activeTab === 'Bug'
        ? {
            Type: 'Bug',
            Title: title,
            ReproSteps: reproSteps,
            SystemInfo: getSystemInfo(),
            Priority: priority,
            Severity: severity,
          }
        : {
            Type: 'Task',
            Title: title,
            Description: description,
            SystemInfo: getSystemInfo(),
          };
  
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');

      if (!token) {
          throw new Error('Authorization token not found');
      }

      const response = await axios.post(`https://${apiURL}/support/create-workitem`, JSON.stringify(payload), {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
      }
    });

    /*
      const response = await fetch(
        'https://${apiURL}/support/create-workitem',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
          body: JSON.stringify(payload),
        }
      );
      */
      const result = await response.data;
      console.log("API response:", result); // Debugging log
  
      if (result.errors && result.errors.length > 0) {
        setErrorMessage('Error: ' + result.errors.join(', '));
      } else if (result.data && result.data.id) {
        setFeedbackId(result.data.id);
      } else {
        setErrorMessage("Unexpected API response: " + JSON.stringify(result));
      }
    } catch (err) {
      setErrorMessage('Network error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // If we have a feedbackId, show the success modal
  if (feedbackId) {
    return (
      <FeedbackSuccessModal
        feedbackId={feedbackId}
        onClose={onClose}
        onAddAnother={() => {
          // Reset the form to allow adding another
          setFeedbackId(null);
          setTitle('');
          setPriority('1');
          setSeverity('1 - Critical');
          setReproSteps('');
          setDescription('');
        }}
      />
    );
  }

  return (
    <FeedbackModalUI
      activeTab={activeTab}
      title={title}
      priority={priority}
      severity={severity}
      reproSteps={reproSteps}
      description={description}
      errorMessage={errorMessage}
      feedbackId={feedbackId}
      onClose={onClose}
      onTabChange={setActiveTab}
      onTitleChange={setTitle}
      onPriorityChange={setPriority}
      onSeverityChange={setSeverity}
      onReproStepsChange={setReproSteps}
      onDescriptionChange={setDescription}
      onSubmit={handleSubmit}
      loading={loading}
    />
  );
};

export default Feedback;
